///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/filter-criteria.ts"/>


module Meevo.Components.Controls.SmartMover {

    export class PointPromotionsFilter extends CriteriaFilter implements ICriteriaFilter {
        public readonly templateName: FilterTemplateNames;
        public readonly values: any;
        public readonly criteria: {};
        public readonly disabled: boolean;

        constructor(entities: IApiCollection<any>[], options: IDataTemplateFilterOptions, public dataTemplate: IDataTemplate = null) {
            super(entities, options);

            if (dataTemplate) {
                this.disabled = dataTemplate.disabled;
            }
            
            angular.extend(this.criteria, { IncludeInactive: true, IncludeActive: true, IncludeDeleted: true, IsCompleted: false });
            this.templateName = 'point-promotions';
            this.values = {
                pointPromotionState: {IncludeInactive: true, IncludeActive: true, InlcudeDeleted: true, IsCompleted: false}
            };
        }

        updateCriteria() {
            angular.extend(this.criteria, this.values.pointPromotionState);
        }
    }
}